// 앱 사이 이동 1회용 코드(계약 SUPPORT 9 끝 표, K-17 — 토큰 쿼리 주소 대체).
// 보내기: POST /auth/handoff {app} → {code} → 새 탭 <앱>/enter#c=<code>&to=<경로>
//   지원 탭이면 서버가 같은 사람으로 받는 앱 지원 세션을 새로 열고 {code, support:true} → <앱>/support/enter#c=<code>&to=<경로>(D1 11-01)
// 받기: /enter 가 #c=·to 를 읽고 곧바로 주소에서 지운 뒤 POST /auth/handoff/exchange {code} → 그 앱의 일반 로그인 응답.
// admin-hospital·admin-manufacturer 같은 내용 — 앱마다 다른 것은 APP_ROLE 한 줄. 순수 모듈(tests/handoff.test.mjs).
import { readHashParams, safeInternalPath, SUPPORT_ENTER_PATH } from "./supportSession.js";

export { readHashParams, safeInternalPath };
export const APP_ROLE = "MANUFACTURER";
export const ENTER_PATH = "/enter";
// studio 「이용 내역」(W5 — CI-18)
export const STUDIO_USAGE_LOGS_PATH = "/settings?tab=usage-logs";

/** 받는 앱 주소 + 코드·경로를 주소 조각(#)에 실음(서버 로그·Referer 에 남지 않게). support = 지원 진입 코드(받는 앱이 지원 탭으로 저장) */
export const handoffUrl = (base, code, to = "/", support = false) =>
  `${String(base || "").replace(/\/+$/, "")}${support ? SUPPORT_ENTER_PATH : ENTER_PATH}#c=${encodeURIComponent(code)}&to=${encodeURIComponent(to)}`;

/** studio 주소: 설정값(VUE_APP_STUDIO_SERVER) 우선, 없으면 API 주소로 환경을 가림(옛 studio 링크와 같은 표) */
export const studioBase = (configured, apiUrl = "") => {
  if (configured) return configured;
  if (apiUrl.includes("localhost")) return "http://localhost:2214";
  if (apiUrl.includes("intest")) return "https://intest-studio.certi.life";
  if (apiUrl.includes("stg")) return "https://stg-studio.certi.life";
  return "https://studio.certi.life";
};

/** access 토큰(JWT) 본문의 role. 서명은 서버가 보므로 화면은 역할만 확인(읽을 수 없으면 null) */
export const tokenRole = (token) => {
  try {
    const part = String(token).split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const bytes = Uint8Array.from(atob(part), (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)).role || null;
  } catch {
    return null;
  }
};

/** 교환 응답이 이 앱의 일반 로그인 응답인지(토큰 있음 + 역할 맞음) */
export const isAppLogin = (data, role = APP_ROLE) =>
  !!data && typeof data.accessToken === "string" && tokenRole(data.accessToken) === role;
